import { render, staticRenderFns } from "./order-list.vue?vue&type=template&id=774042ef&scoped=true&"
import script from "./order-list.vue?vue&type=script&lang=js&"
export * from "./order-list.vue?vue&type=script&lang=js&"
import style0 from "./order-list.vue?vue&type=style&index=0&id=774042ef&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "774042ef",
  null
  
)

export default component.exports